// タグの制御（修正版）
(function(){
  // カテゴリー: 要素内が空の場合、出力しない
  function removeEmptyCategories(container) {
    container.querySelectorAll('.js-category').forEach(function(tag) {
      if (tag.textContent.trim() === '') {
        tag.remove();
      }
    });
  }

  // ハッシュタグ: 「#のみ」の場合、出力しない（ハッシュタグ名が存在する場合のみ出力）
  function removeEmptyHashtags(container) {
    container.querySelectorAll('.js-hashtag').forEach(function(tag) {
      let hashtagSpan = tag.querySelector('.mod-hashtag__item, .stories-tagarea__hashtag');
      if (hashtagSpan && hashtagSpan.textContent.trim() === '#') {
        tag.remove();
      }
    });
  }

  // 一覧ページ
  let storiesList = document.querySelector('.js-stories-list');
  if (storiesList) {
    removeEmptyCategories(storiesList);
    removeEmptyHashtags(storiesList);
  }

  // 詳細ページ
  let detailHead = document.querySelector('.js-stories-detail-head');
  if (detailHead) {
    removeEmptyCategories(detailHead);
    removeEmptyHashtags(detailHead);
  }
})();


// 最新ストーリー
(function () {

  let DUMMY_IMG = '/common/images/default.webp';
  let MAX_COUNT = 4;
  let SLIDES_PER_VIEW = 2;
  let carouselIndex = 0;
  let isCarouselMode = false;
  let carouselEl = null;
  let trackEl = null;

  function getNewsId() {
    let path = location.pathname;
    let fileName = path.split('/').filter(Boolean).pop() || '';
    return fileName.replace(/\.html$/, '');
  }

  function getAjaxBase() {
    return location.pathname.indexOf('/en/') !== -1 ? '/ajax/en/stories/' : '/ajax/stories/';
  }

  function fetchJson(url) {
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('fetch error: ' + url + ' (' + res.status + ')');
      return res.json();
    });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function createCard(item) {
    let isEn = location.pathname.indexOf('/en/') !== -1;
    let detailBase = isEn ? '/en/stories/detail/' : '/stories/detail/';
    let nameKey = isEn ? 'cf_st_name_en' : 'cf_st_name_ja';
    let href     = item.cf_s_url ? '/' + item.cf_s_url + '/' : detailBase + item._key + '.html';
    let imgSrc   = item.cf_s_thum_img ? '/stories/stories_file/file/'+ item.cf_s_thum_img : DUMMY_IMG;
    let imgAlt   = item.cf_s_thum_img_alt || '';
    let imgTitle = item.cf_s_thum_img_title || '';
    let title    = item.cf_s_title || '';
    let tags     = item.cf_s_tags || [];
    let type     = item.cf_s_type || '';
    let icon = '';

    let categories = tags.filter(function (t) {
      return t.cf_st_group_code !== 'hashtag' && t.cf_st_group_code !== 'output';
    });
    let hashtags = tags.filter(function (t) {
      return t.cf_st_group_code === 'hashtag';
    });
    

    let categoriesHtml = '';
    if (categories.length) {
      let catSpans = categories.map(function (c) {
        return '<span class="js-category cf_s_tags">' +
                 '<span class="stories-tagarea__category">' + escHtml(c[nameKey]) + '</span>' +
               '</span>';
      }).join('');
      categoriesHtml = '<div class="stories-tagarea__categories">' + catSpans + '</div>';
    }

    let hashtagsHtml = '';
    if (hashtags.length) {
      let hashSpans = hashtags.map(function (h) {
        return '<span class="js-hashtag cf_s_tags">' +
                 '<span class="stories-tagarea__hashtag">#' + escHtml(h[nameKey]) + '</span>' +
               '</span>';
      }).join('');
      hashtagsHtml = '<div class="stories-tagarea__hashtags">' + hashSpans + '</div>';
    }

    let a = document.createElement('a');
    a.href = href;
    if(type === 2) { // 添付ファイル
      a.target = '_blank';
      a.href = item.cf_s_attachment_file;
      if(item.cf_s_attachment_file.includes('.pdf')) {
        icon = '<svg aria-label="PDF"><use href="/common/svg/sprite.svg#pdf"></use></svg>';
      }
      icon += ' <span class="__fileSize">('+ fileSize(item.cf_s_attachment_file_size) +')</span>';
    } else if(type === 3) { //  URL指定
      a.href = item.cf_s_url;
      if(item.cf_s_url.includes('//')) {
        a.target = '_blank';
        a.rel = 'noopener';
        icon = '<svg aria-hidden="true"><use href="/common/svg/sprite.svg#blank"></use></svg>';
        if(item.cf_s_url_file_size !== '' && item.cf_s_url_file_size !== undefined) {
          icon += ' <span class="__fileSize">('+ fileSize(item.cf_s_url_file_size) +')</span>';
        }
      }
    }
    a.className = 'stories-card';
    a.innerHTML =
      '<div class="stories-card__frame">' +
        '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(imgAlt) + '" title="' + escHtml(imgTitle) + '" class="stories-card__img" />' +
      '</div>' +
      '<div class="stories-card__content">' +
        '<p class="stories-card__title">'+
        '<span class="_text">' + escHtml(title) + '</span>'+
        icon +
        '</p>' +
        categoriesHtml +
        hashtagsHtml +
      '</div>';
    return a;
  }

  function updateCarousel(totalCards) {
    if (!trackEl) return;
    trackEl.style.transform = 'translateX(-' + (carouselIndex * 50) + '%)';
    let prevBtn = carouselEl.querySelector('.mod-card-carousel__btn--prev');
    let nextBtn = carouselEl.querySelector('.mod-card-carousel__btn--next');
    if (prevBtn) prevBtn.style.display = carouselIndex > 0 ? 'flex' : 'none';
    if (nextBtn) nextBtn.style.display = carouselIndex < totalCards - SLIDES_PER_VIEW ? 'flex' : 'none';
  }

  function setupCarousel() {
    let grid = document.querySelector('.top-stories-section__card');
    if (!grid) return;
    let isMobile = window.innerWidth <= 1024;
    let cards = Array.from(grid.querySelectorAll(':scope > .stories-card'));

    if (isMobile && !isCarouselMode) {
      let cards = Array.from(grid.querySelectorAll(':scope > .stories-card'));
      if (!cards.length) return;

      isCarouselMode = true;
      carouselIndex = 0;

      carouselEl = document.createElement('div');
      carouselEl.className = 'top-stories-card-carousel';

      trackEl = document.createElement('div');
      trackEl.className = 'top-stories-card-carousel__track';

      cards.forEach(function (card) {
        let slide = document.createElement('div');
        slide.className = 'top-stories-card-carousel__slide';
        slide.appendChild(card);
        trackEl.appendChild(slide);
      });

      carouselEl.appendChild(trackEl);

      let prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--prev';
      prevBtn.setAttribute('aria-label', '前へ');
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_left"></use></svg>';
      prevBtn.addEventListener('click', function () {
        carouselIndex = carouselIndex > 0 ? carouselIndex - 1 : Math.max(0, cards.length - SLIDES_PER_VIEW);
        updateCarousel(cards.length);
      });

      let nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'mod-card-carousel__btn mod-card-carousel__btn--next';
      nextBtn.setAttribute('aria-label', '次へ');
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>';
      nextBtn.addEventListener('click', function () {
        carouselIndex = carouselIndex < cards.length - SLIDES_PER_VIEW ? carouselIndex + 1 : 0;
        updateCarousel(cards.length);
      });

      carouselEl.appendChild(prevBtn);
      carouselEl.appendChild(nextBtn);

      grid.parentNode.insertBefore(carouselEl, grid);
      grid.style.display = 'none';

      updateCarousel(cards.length);

    } else if (!isMobile && isCarouselMode) {
      isCarouselMode = false;
      carouselIndex = 0;

      if (carouselEl) {
        let cards2 = Array.from(carouselEl.querySelectorAll('.stories-card'));
        cards2.forEach(function (card) { grid.appendChild(card); });
        carouselEl.remove();
        carouselEl = null;
        trackEl = null;
      }
      grid.style.display = '';
    }
  }

  function init() {
    let container = document.querySelector('.js-latest-stories');    
    if (!container) return;

    let newsId = getNewsId();
    if (!newsId) return;

    let ajaxBase = getAjaxBase();

    fetchJson(ajaxBase + newsId + '.json')
      .then(function (currentJson) {
        let currentItem = (currentJson.rt_bn_stories_list || [])[0] || currentJson;

        let tags = (currentItem.cf_s_tags || [])
          .filter(function (t) { return t.cf_st_group_code !== 'hashtag'; })
          .map(function (t) { return t._key; })
          .filter(Boolean);

        if (!tags.length) return;

        return Promise.allSettled(
          tags.map(function (tag) { return fetchJson(ajaxBase + 'tag/' + tag + '.json'); })
        ).then(function (tagJsons) {
          let seen = new Set([newsId]);
          let allItems = [];

          tagJsons.forEach(function (result) {
            if (result.status !== 'fulfilled') return;
            let data = result.value;
            let list = Array.isArray(data) ? data : (data.rt_bn_stories_list || data.list || data.items || []);
            list.forEach(function (item) {
              let key = String(item._key || '');
              if (!key || seen.has(key)) return;
              seen.add(key);
              allItems.push(item);
            });
          });

          allItems.sort(function (a, b) {
            let dateA = String(a.cf_s_date || '');
            let dateB = String(b.cf_s_date || '');
            if (dateB !== dateA) return dateB.localeCompare(dateA);
            return String(b._key || '').localeCompare(String(a._key || ''));
          });

          let displayItems = allItems.slice(0, MAX_COUNT);

          container.innerHTML = '';
          displayItems.forEach(function (item) {
            container.appendChild(createCard(item));
          });

          setupCarousel();
        });
      })
      .catch(function (err) {
        console.error('[latest-stories] error:', err);
      });
  }

  function fileSize(_bytes) {	
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (_bytes === 0) {
      return 'n/a';
    }
    let i = parseInt(Math.floor(Math.log(_bytes) / Math.log(1024)), 10);
    if (i === 0) {
      return _bytes + ' ' + sizes[i];
    }
    return (_bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
  };

  window.addEventListener('resize', setupCarousel);

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();